var lib_core = require("lib-core");
var showUI;
if(showUI = (typeof window !== 'undefined'))
    var ui_extensions = require("ui-extensions");

var Editor2DController = require("./../editor2D/editor2DController.js");
var FlipStateMachine = require("./flipStateMachine.js");
var FlipModel = require("./flipModel.js");

var FlipController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);

    lib_core.GuiEvents.addEvents({
        FLIP_HOR_BUTTON: {id: 'abs_22', name: "FLIP_HOR_BUTTON", isGuiButton: true},
        FLIP_VER_BUTTON: {id: 'abs_23', name: "FLIP_VER_BUTTON", isGuiButton: true}
    });
};
lib_core.inherit(FlipController, lib_core.Controller);
if(showUI) {
    FlipController.inject = {
        editor2DController : Editor2DController,
        tabController : ui_extensions.TabController
    };
} else {
    FlipController.inject = {
        editor2DController : Editor2DController
    };
}

module.exports = FlipController;

FlipController.prototype.beforeLoad = function() {
    lib_core.Controller.prototype.beforeLoad.call(this);

    this.tabController.getView().registerButton({
        name: 'Horizontal Flip',
        title: 'Horizontal Flip (Shift + R)',
        sortOrder: 20,
        eventType: lib_core.GuiEvents.FLIP_HOR_BUTTON,
        style: {
            icon: 'icon-flip-horizontal.svg',
        },
        group: "modifier"
    });

    this.tabController.getView().registerButton({
        name: 'Vertical Flip',
        title: 'Vertical Flip (F)',
        sortOrder: 21,
        eventType: lib_core.GuiEvents.FLIP_VER_BUTTON,
        style: {
            icon: 'icon-flip-vertical.svg',
        },
        group: "modifier"
    });
};

FlipController.prototype.createStateMachine = function () {
    return new FlipStateMachine(this.root, this.getModel(), this.parent().getModel());
};

FlipController.prototype.createModel = function () {
    return new FlipModel();
};

FlipController.prototype.afterLoad = function () {
    var self = this;
    var stateMachineCreator = function(){
        return self.createStateMachine();
    };
    var editorController = this.editor2DController;
    editorController.getStatemachine().append(this.name(), stateMachineCreator, /.*/, null, lib_core.StateMachine.CIRCULAR, null);
};
